import { LoadingOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, Modal, Select, Spin, Table } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { getAllEquipInspectionHistory, getAllInspections, updateTableLocation, ExportAllEquipInspectionHistory } from '../../Services/LocomotiveServices'

const InspectionModalDue = (props) => {

    let { open, close } = props
    let [form] = Form.useForm()
    const [showFilters, setShowFilters] = useState(true)
    const [selectedAllFilters, setSelectedAllFilters] = useState({
        procedure: false,
        location: false
    })
    const [inspectionHistory, setInspectionHistory] = useState([])
    const [filterArrays, setFilterArrays] = useState({
        procedure: [],
        location: []
    })
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 20,
        total: inspectionHistory?.length || 0,
    })
    const [loaders, setLoaders] = useState({
        filter: false,
        table: false
    })
    const [inspectionType, setInspectionType] = useState(undefined)
    const [dueDates, setDueDates] = useState({
        due_from: null,
        due_to: null
    })
    const [listings, setListings] = useState({
        procedure: [],
        location: [],
        comp_federal: []
    })
    const handleOnChange_Location = (value) => {
        if (value.includes('all')) {
            const allValues = listings?.location?.map(x => x.id);
            form.setFieldsValue({ location: allValues.filter(val => val !== 'all') });
            setFilterArrays(prev => { return { ...prev, location: allValues.filter(val => val !== 'all') } })
        } else {
            form.setFieldsValue({ location: value });
            setFilterArrays(prev => { return { ...prev, location: value } })

        }
    };
    const handleOnChange_Procedure = (value) => {
        if (value.includes('all')) {
            const allValues = listings?.procedure?.map(x => x.id);
            form.setFieldsValue({ procedure: allValues.filter(val => val !== 'all') });
            setFilterArrays(prev => { return { ...prev, procedure: allValues.filter(val => val !== 'all') } })
        } else {
            form.setFieldsValue({ procedure: value });
            setFilterArrays(prev => { return { ...prev, procedure: value } })
        }
    };
    let filterFields = [
        {
            name: "type", label: "Comp/Federal", render:
                <Select
                    placeholder="Select Type"
                    style={{ width: "120px" }}
                    onChange={value => {
                        setInspectionType(value)
                        setFilterArrays((prev) => {
                            return {
                                ...prev, procedure: []
                            }
                        })
                        form.setFieldsValue({
                            procedure: undefined
                        })
                    }}
                    options={[{ label: "All", value: "all" }, { label: "Company", value: "COMPANY" }, { label: "Federal", value: "FEDERAL" }]}
                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                />
        },
        {
            name: "procedure", label: "Procedure", render:
                <Select
                    mode="multiple"
                    showSearch
                    allowClear
                    style={{
                        maxHeight: "100px", overflowY: "auto", width: "330px", marginTop: "6px"
                    }}
                    placeholder="Select procedure"
                    onChange={handleOnChange_Procedure}
                    options={[{ id: "all", InspName: "All" }, ...listings?.procedure]?.map(x => { return { value: x.id, label: x.InspName } })}
                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                />
        },
        {
            name: "due_from", label: "Due From", render:
                <DatePicker
                    onChange={value => setDueDates(prev => { return { ...prev, due_from: value } })}
                    disabledDate={current => dueDates?.due_to && current.isSameOrAfter(dueDates?.due_to, 'day')}
                    format="MM-DD-YYYY"
                    style={{ width: "130px" }}
                />
        },
        {
            name: "due_to", label: "Due To", render:
                <DatePicker
                    onChange={value => setDueDates(prev => { return { ...prev, due_to: value } })}
                    disabledDate={current => dueDates?.due_from && current.isSameOrBefore(dueDates?.due_from, 'day')}
                    format="MM-DD-YYYY"
                    style={{ width: "130px" }}
                />
        },
        {
            name: "location", label: "Location", render:
                <Select
                    mode="multiple"
                    showSearch
                    allowClear
                    onChange={handleOnChange_Location}
                    style={{
                        maxHeight: "100px", overflowY: "auto", width: "450px", marginTop: "6px"
                    }}
                    placeholder="Select Location"
                    options={[{ id: "all", title: "All" }, ...listings?.location]?.map(x => { return { value: x.id, label: x.title } })}
                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}

                />
        }

    ]

    let FormItemContainer = ({ item }) => {
        return <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <span style={{ fontSize: "10px", fontWeight: "600" }}>{item?.label}</span>
            <Form.Item name={item?.name}>
                {item?.render}
            </Form.Item>
        </div>
    }

    let columns = [
        {
            title: 'Asset',
            dataIndex: 'asset',
            key: 'asset',
            render: (_, record) => {
                return <div>
                    <span>{record?.EquipUID || "N/A"}</span>
                    <br />
                    <span>Type: {record?.Loco_Model || "N/A"}</span>
                </div>
            },
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
            render: (_, record) => {
                return <span>{record?.TGSLocation?.Abv || "N/A"}</span>
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (_, record) => {
                return <span>{record?.status?.IS_OS || "N/A"}</span>
            },
        },
        {
            title: 'Procedures',
            dataIndex: 'procedures',
            key: 'procedures',
            render: (_, record) => {
                return record?.EquipInspectionHistories?.length
                    ? record?.EquipInspectionHistories?.map(x =>
                        <>
                            <span>{`** ${moment(x?.NextDueDate)?.format("MM-DD-YYYY")} * - ${x?.EquipInspectionRef?.InspName}`}</span>
                            <br />
                        </>
                    )
                    : <></>
            },
        },
    ]

    const fetchProcedure = async () => {
        setLoaders(prev => { return { ...prev, filter: true } })
        const response = await getAllInspections(inspectionType === "all" ? undefined : inspectionType)
        if (response?.httpStatus === 200) {
            setListings(prev => { return { ...prev, procedure: response?.data } })
            setLoaders(prev => { return { ...prev, filter: false } })
        }
        setLoaders(prev => { return { ...prev, filter: false } })
    }

    const fetchLocation = async () => {
        setLoaders(prev => { return { ...prev, filter: true } })
        const response = await updateTableLocation()
        if (response?.httpStatus === 200) {
            setListings(prev => { return { ...prev, location: response?.data } })
            setLoaders(prev => { return { ...prev, filter: false } })
        }
        setLoaders(prev => { return { ...prev, filter: false } })

    }
    const fetchInspectionsHistory = async (payload) => {
        setLoaders(prev => { return { ...prev, table: true } })
        const response = await getAllEquipInspectionHistory(payload ? payload : {})
        if (response?.httpStatus === 200) {
            setInspectionHistory(response?.data)
            setLoaders(prev => { return { ...prev, table: false } })
            setPagination(prev => { return { ...prev, current: 1 } })
        }
        setLoaders(prev => { return { ...prev, table: false } })
    }
    const handleExportButtonClick = async () => {
        try {

            let body = {
                location: filterArrays?.location?.length ? filterArrays?.location : undefined,
                procedure: filterArrays?.procedure?.length ? filterArrays?.procedure : undefined,
                type: inspectionType === 'all' ? undefined : inspectionType,
                due_from: dueDates?.due_from ? moment(dueDates?.due_from)?.format("YYYY-MM-DD") : undefined,
                due_to: dueDates?.due_to ? moment(dueDates?.due_to)?.format("YYYY-MM-DD") : undefined,
                procedure_all: selectedAllFilters?.procedure,
                location_all: selectedAllFilters?.location
            }

            const response = await ExportAllEquipInspectionHistory(body);
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `InspectionDue.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);


        } catch (error) {
            console.error('Error exporting data:', error);
        }
    }
    const onSubmit = async (values) => {

        let body = {
            location: values?.location?.length ? values?.location : undefined,
            procedure: values?.procedure?.length ? values?.procedure : undefined,
            type: inspectionType === 'all' ? undefined : inspectionType,
            due_from: dueDates?.due_from ? moment(dueDates?.due_from)?.format("YYYY-MM-DD") : undefined,
            due_to: dueDates?.due_to ? moment(dueDates?.due_to)?.format("YYYY-MM-DD") : undefined,
            procedure_all: selectedAllFilters?.procedure,
            location_all: selectedAllFilters?.location
        }
        await fetchInspectionsHistory(body)
    }
    const hanldeAllCheck = () => {
        setSelectedAllFilters((prev) => { return { ...prev, procedure: filterArrays?.procedure?.length == listings?.procedure?.length ? true : false } })
        setSelectedAllFilters((prev) => { return { ...prev, location: filterArrays?.location?.length == listings?.location?.length ? true : false } })
    }
    useEffect(() => {
        fetchProcedure()
    }, [inspectionType])
    useEffect(() => {
        if (open) {
            fetchProcedure()
            fetchLocation()
            // fetchInspectionsHistory()
        }
    }, [open])

    useEffect(() => {
        hanldeAllCheck()
    }, [filterArrays?.procedure, filterArrays?.location, listings?.procedure, listings?.location])
    return (
        <Modal
            open={open}
            style={{
                top: "20px"
            }}
            onCancel={() => {
                close()
                form.resetFields()
                setDueDates({
                    due_from: null,
                    due_to: null
                })
                setInspectionType(undefined)
                setFilterArrays({
                    location: [],
                    procedure: []
                })
            }}
            footer={null}
            title={<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingRight: "20px" }}>
                <span>Inspection Due</span>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "10px" }}>

                    <Button
                        onClick={handleExportButtonClick}
                        style={{
                            display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "10px", background: "#2963ad",
                            color: "white", opacity: !filterArrays?.location?.length && !filterArrays?.procedure?.length && !dueDates?.due_from && !dueDates?.due_to && !inspectionType ? 0.4 : 1
                        }}
                        disabled={!filterArrays?.location?.length && !filterArrays?.procedure?.length && !dueDates?.due_from && !dueDates?.due_to && !inspectionType ? true : false}
                    >
                        Export
                    </Button>
                    <Button onClick={() => setShowFilters(!showFilters)} style={{ background: "white", color: "#2963ad" }}>
                        {showFilters ? "Hide" : "Show"} Filters
                    </Button>
                </div>

            </div>
            }
            width={"70%"}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <Spin
                    spinning={loaders?.filter || false}
                    indicator={<LoadingOutlined
                        style={{
                            fontSize: 24,
                        }}
                        spin
                    />}>
                    {showFilters && <div style={{ background: "#e5e5e5", padding: "10px", borderRadius: "5px" }}>
                        <Form
                            onFinish={onSubmit}
                            onFinishFailed={err => console.log(err)}
                            form={form}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: "20px", flexWrap: "wrap" }}>
                                {filterFields?.map(field => <FormItemContainer item={field} />)}
                            </div>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "10px" }}>
                                <Button onClick={() => {
                                    form.resetFields()
                                    setDueDates({
                                        due_from: null,
                                        due_to: null
                                    })
                                    setInspectionType(undefined)
                                    setInspectionHistory([])
                                    setFilterArrays({
                                        location: [],
                                        procedure: []
                                    })

                                }}
                                    style={{ background: "white", color: "#2963ad", opacity: !filterArrays?.location?.length && !filterArrays?.procedure?.length && !dueDates?.due_from && !dueDates?.due_to && !inspectionType ? 0.4 : 1 }}
                                    disabled={!filterArrays?.location?.length && !filterArrays?.procedure?.length && !dueDates?.due_from && !dueDates?.due_to && !inspectionType ? true : false}
                                >
                                    Reset
                                </Button>
                                <Button
                                    htmlType='submit'
                                    style={{
                                        background: "#2963ad",
                                        color: "white",
                                        opacity: !filterArrays?.location?.length && !filterArrays?.procedure?.length && !dueDates?.due_from && !dueDates?.due_to && !inspectionType ? 0.4 : 1

                                    }}
                                    disabled={!filterArrays?.location?.length && !filterArrays?.procedure?.length && !dueDates?.due_from && !dueDates?.due_to && !inspectionType ? true : false}
                                >
                                    Apply
                                </Button>
                            </div>
                        </Form>

                    </div>}
                </Spin>
                <Spin
                    spinning={loaders?.table || false}
                    indicator={<LoadingOutlined
                        style={{
                            fontSize: 24,
                        }}
                        spin
                    />}>
                    <Table
                        columns={columns}
                        dataSource={inspectionHistory}
                        className="inspection-due-table"
                        scroll={{
                            x: 'max-content',
                            y: 450
                        }}
                        pagination={inspectionHistory?.length > 10 ? {
                            ...pagination,
                            pageSizeOptions: ['10', '20', '50', '100'],
                            showSizeChanger: true,
                            onChange: (page) => {
                                setPagination(prev => ({ ...prev, current: page, }));
                            },
                            onShowSizeChange: (size, page) => {
                                setPagination(prev => ({ ...prev, pageSize: page }));
                            }
                        } : false}
                    />
                </Spin>
            </div>

        </Modal >
    )
}

export default InspectionModalDue